import './SlidesContainer.css'
function SlidesContainer({children,className}) {

    return (
        <div className={"slides-container " + (className ? className : "")}>
            {children}
        </div>
    )
}

export default SlidesContainer;